export default __webpack_public_path__ + "60caf523081a1702b2c7729d5d92d306.png";